import { createContext, useCallback, useContext, useMemo, useState } from "react";

// Lets a dynamic route (e.g. a blog post) supply its own SEO data, since SeoHead
// otherwise resolves everything from a static pathname -> seo map (see seo/pages.js)
// which has no entry for routes like /blog/:slug.
const SeoOverrideValueContext = createContext(null);
const SeoOverrideSetterContext = createContext(null);

export function SeoProvider({ children }) {
    const [override, setOverride] = useState(null);

    const setSeoOverride = useCallback((data) => setOverride(data), []);
    const clearSeoOverride = useCallback(() => setOverride(null), []);
    const setters = useMemo(() => ({ setSeoOverride, clearSeoOverride }), [setSeoOverride, clearSeoOverride]);

    return (
        <SeoOverrideValueContext.Provider value={override}>
            <SeoOverrideSetterContext.Provider value={setters}>
                {children}
            </SeoOverrideSetterContext.Provider>
        </SeoOverrideValueContext.Provider>
    );
}

export function useSeoOverrideValue() {
    return useContext(SeoOverrideValueContext);
}

// Call setSeoOverride(seoObject) once page data is ready, and clearSeoOverride() on
// unmount so leaving the route falls back to the static pathname-based SEO again.
export function useSeoOverride() {
    return useContext(SeoOverrideSetterContext);
}
